module.exports = __webpack_public_path__ + "img/vertical_4_3_3.770db42f.png";